import cx from './styles.less';
import React from 'react';
import FocusLock from 'react-focus-lock';
import { Btn } from '../react-toolbox-redesign/button';

export interface MiniMenuItem {
    key: string;
    name: string;
    /* tslint:disable-next-line */
    function?: Function;    
    functionitem?: any;
    iconName: string;
}

// codesandbox.io/s/jt4dh?file=/src/components/Menu.tsx:422-437
export default class MiniMenu extends React.Component<any, any> {
    items = this.props.items;
    showMiniMenu=this.props.showMiniMenu;
    toggleMiniMenu=this.props.toggleMiniMenu;

    onToggle = () => {
        this.toggleMiniMenu();
    } 
  
    public render() { 
        this.items = this.props.items;
        this.showMiniMenu=this.props.showMiniMenu;

        return (
            <div>
                <Btn 
                    type="button" 
                    className={'btn'} 
                    extraClassNames={['icon-btn', 'dots_vertical']} 
                    aria-label={'Mini menu activeren'}
                    aria-haspopup={true}                        
                    tabIndex={0}                                                                                                                        
                    onClick={() => this.onToggle()}
                    disabled={false}>
                        <span className="dots_vertical"></span>
                </Btn> 
                {this.showMiniMenu ?
                    <FocusLock disabled={!this.showMiniMenu}>
                    <div tabIndex={-1} 
                         className={cx(this.showMiniMenu ? ['active', 'test', 'minimenu'] : 'minimenu')}
                    >
                        <ul>
                            {this.items ? this.items.map(
                                (item: MiniMenuItem) => {
                                    return (
                                        <li tabIndex={0}
                                            key={item.key}
                                            onKeyDown={(evt: React.KeyboardEvent<HTMLElement>) => {
                                                return handleKeyDown(evt, () => this.toggleMiniMenu(!this.showMiniMenu), ()=>item.function(item.functionitem));}
                                            }
                                            onClick={()=>item.function(item.functionitem)}>                                             
                                            {item.name}
                                        </li>)
                                ;})
                            :null}
                        </ul>
                    </div>                
                    </FocusLock>
                :null}
            </div>
        );
    }
}

/* tslint:disable-next-line */
function handleKeyDown(evt: React.KeyboardEvent<HTMLElement>, functionEsc: Function, functionEnter: Function) {
    if (evt.key==='Escape') { evt.preventDefault(); functionEsc(); }
    if (evt.key==='Enter') { evt.preventDefault(); functionEnter(); }
}   



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/react-toolbox-extended/mini-menu.tsx